module.exports = __webpack_public_path__ + "static/media/hud_plant_marker.15e5e792.svg";